// // import { Navigate } from 'react-router-dom';
// // import { useAuth } from '../hooks/useAuth';
// // import Layout from '../components/layout/Layout';
// // import Loader from '../components/common/Loader/Loader';

// // const ProtectedRoute = ({ children, roles = [] }) => {
// //     const { user, isAuthenticated, loading } = useAuth();

// //     if (loading) {
// //         return (
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'center',
// //                 alignItems: 'center',
// //                 height: '100vh'
// //             }}>
// //                 <Loader size="large" />
// //             </div>
// //         );
// //     }

// //     if (!isAuthenticated) {
// //         return <Navigate to="/login" replace />;
// //     }

// //     if (roles.length > 0 && user && !roles.includes(user.role)) {
// //         return <Navigate to="/unauthorized" replace />;
// //     }

// //     return <Layout>{children}</Layout>;
// // };

// // export default ProtectedRoute;
// import { Navigate, useLocation } from 'react-router-dom';
// import { useAuth } from '../hooks/useAuth';
// import Layout from '../components/layout/Layout';
// import Loader from '../components/common/Loader/Loader';

// const loaderWrapperStyle = {
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   height: '100vh',
// };

// const hasPermission = (permissions, moduleName, action) => {
//   if (!moduleName || !action) return true;

//   const allowedActions = permissions?.[moduleName];
//   return Array.isArray(allowedActions) && allowedActions.includes(action);
// };

// const ProtectedRoute = ({ children, module = null, action = null }) => {
//   const location = useLocation();
//   const { isAuthenticated, loading, permissions } = useAuth();

//   if (loading) {
//     return (
//       <div style={loaderWrapperStyle}>
//         <Loader size="large" />
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace state={{ from: location }} />;
//   }

//   if (!hasPermission(permissions, module, action)) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return <Layout>{children}</Layout>;
// };

// export default ProtectedRoute;
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from '../components/layout/Layout';
import Loader from '../components/common/Loader/Loader';

const loaderWrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

const hasPermission = (permissions, permission) => {
  if (!permission) return true;
  return permissions?.[permission] === true;
};

const ProtectedRoute = ({ children, permission = null }) => {
  const location = useLocation();
  const { isAuthenticated, loading, permissions } = useAuth();

  console.log('ProtectedRoute check:', {
    path: location.pathname,
    permission,
    permissions,
    allowed: hasPermission(permissions, permission),
  });

  if (loading) {
    return (
      <div style={loaderWrapperStyle}>
        <Loader size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasPermission(permissions, permission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;